<template>
  <form id="form-register-page">
    <div class="mb-3">
      <input
        type="email"
        class="form-control"
        id="form-email-register"
        placeholder="Email Address"
        v-model="email"
      />
    </div>
    <div class="mb-3">
      <input
        type="password"
        class="form-control"
        id="form-password-register"
        placeholder="Password"
        v-model="password"
      />
    </div>
    <div class="mb-3">
      <input
        type="username"
        class="form-control"
        id="form-username-register"
        placeholder="Username"
        v-model="username"
      />
    </div>
    <div class="mb-3 text-center">
      <button type="submit" class="btn btn-primary text-center" @click.prevent="RegisterForm">Register</button>
    </div>
  </form>
</template>

<script>
export default {
    name: "FormRegister",
    data() {
      return {
        email: '',
        password: '',
        username: ''
      }
    },
    methods: {
      RegisterForm() {
        const {email, password, username} = this
        this.$emit('clickRegister', {email, password, username})
      }
    }
};
</script>

<style>
</style>